const HomePage = () => import("./pages/HomePage.vue");
const ThankYou = () => import("./components/ThankYou.vue");
export const GodrejRoutes = [
  {
    path: "/godrej",
    component: HomePage,
    meta: {
      title: "Godrej - Share Your Feedback & Get Rewarded"
    }
  },
  {
    path: "/godrej/thank-you",
    component: ThankYou,
    meta: {
      title: "Godrej - Share Your Feedback & Get Rewarded"
    }
  }
];
